import { getTenant } from '../helpers';
import { api } from './api';

export function getTimeSpentUserDataAPI(username: string, callback) {
  const today = new Date();

  // Calculate the first day of the week (6 days before today)
  const firstDayOfWeek = new Date(today);
  firstDayOfWeek.setDate(today.getDate() - 6);

  const formattedFirstDay = formatDate(firstDayOfWeek);
  const formattedLastDay = formatDate(today);

  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdperlearner.perlearnerOrgsUsersOverviewTimeOverTimeRetrieve(
        ...args
      ),
    getTenant(),
    username,
    {
      endDate: formattedLastDay,
      startDate: formattedFirstDay,
    }
  )((err, data, response) => console.log(err, callback(data?.data), response));
}

export function getUserActivityDataAPI(username, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdperlearner.perlearnerOrgsUsersInfoRetrieve(...args),
    getTenant(),
    username,
    { meta: 'true' }
  )((err, data, response) => console.log(err, callback(data), response));
}

export function getMostPopularCourseAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdperlearner.perlearnerOrgsUsersActivityRetrieve(...args),
    getTenant(),
    username,
    {}
  )((err, data, response) => findMostPopularCourse(callback, data?.data));
}

function getCourseWithMostTime(data) {
  let courseWithMostTime = null;
  let maxTimeInvested = -1;

  data?.forEach(function (course) {
    const timeInvested = parseInt(course?.time_invested);

    if (timeInvested > maxTimeInvested) {
      maxTimeInvested = timeInvested;
      courseWithMostTime = course;
    }
  });

  return courseWithMostTime;
}
function findMostPopularCourse(callback, data) {
  const courseWithMostTime = getCourseWithMostTime(data);
  callback(courseWithMostTime);
}

export function getUserSkillLeaderBoardAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) =>
      api.iblaxdskillsapi.skillsOrgsSkillsUsersPointPercentileRetrieve(...args),
    getTenant(),
    username
  )((err, data, response) => console.log(err, callback(data), response));
}

export function getUserCoursesTotalAPI(username: string, callback) {
  try {
    api.ibldmcourses.getUserCourses({ username }, function (data) {
      const courses = Array.isArray(data) ? data : [];
      callback(courses.length);
    });
  } catch (error) {
    callback(0);
  }
}

export function getUserPathwaysAndResourcesTotalAPI(
  username: string,
  callback
) {
  api.ibledxpathway.getUserPathways({ username }, function (data) {
    const pathways = data?.body;
    let totalResources = 0;
    pathways.forEach((pathway, i) => {
      totalResources += pathway.path.length;
    });
    const returnData = {
      pathways: pathways.length,
      totalResources: totalResources,
    };
    callback(returnData);
  });
}

export function getUserProgramsTotalAPI(
  username: string,
  userId: number,
  callback
) {
  const data = {
    user_id: userId,
  };
  api.ibldmprograms.getUserPrograms(data, function (data) {
    const programs = data;
    let programs_count;
    if (!programs) {
      programs_count = 0;
    } else {
      programs_count = programs.length;
    }
    callback(programs_count);
  });
}

export function getUserTotalCredentialsAPI(username: string, callback) {
  api.iblaxdApiCallWrapper(
    (args) => api.iblaxdcredapi.credentialsOrgsUsersAssertionsRetrieve(...args),
    getTenant(),
    username,
    {}
  )((err, data, response) => callback(response?.body[0]?.data?.length || 0));

}
export function calculateDaysTotal(data) {
  const daysTotal = {};
  for (const date in data) {
    if (data?.hasOwnProperty(date)) {
      const [year, month, day] = date.split('-');
      const key = `${year}-${month}-${day}`;
      if (daysTotal.hasOwnProperty(key)) {
        daysTotal[key] += (data[date] / 60).toFixed(0);
      } else {
        daysTotal[key] = (data[date] / 60).toFixed(0);
      }
    }
  }
  return daysTotal;
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
